export default __webpack_public_path__ + "static/media/flow3_1.c8ffd410.jpg";